<i18n lang="yaml">
  pt:
    title: "Configurações do projeto"
</i18n>

<template>
  <div
    data-grid="column"
    class="settings__menu grid--va-bottom"
  >
    <h2 class="mt-2 text-right">
      {{ $t("title") }}
    </h2>

    <ul
      class="items"
      data-grid="column"
    >
      <li
        v-for="(option, oid) in menuOptions"
        :key="option.routeName"
        data-grid="nowrap"
        class="item"
        :class="{
          'mt-1': oid,
          'item--active': routeMatched(option.routeName)
        }"
      >
        <router-link
          data-grid="nowrap"
          :to="routeInto(option.routeName)"
          class="item__link grid--va-center grid--right w-100 pe-2 p-relative"
          :class="{
            'item__link--active': routeMatched(option.routeName)
          }"
        >
          {{ option.title }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SettingsMenu',

  props: {
    menuOptions: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  methods: {
    routeInto (routeName) {
      const { query } = this.$route

      return {
        query,
        name: routeName
      }
    },

    routeMatched (routeName) {
      return this.$route.name === routeName
    }
  }
})
</script>

<style lang="scss" scoped>
  .settings__menu {
    z-index: 2;
    padding: 32px 30px;
    box-sizing: border-box;
    background-color: rgb(var(--gray8));

    h2 {
      max-width: 70%;
      margin-bottom: 32px;
      color: rgb(var(--white));
    }

    .item {
      list-style: none;

      &--lock {
        opacity: 0.4;
        user-select: none;
        pointer-events: none;
      }

      &__link {
        height: 45px;
        border-radius: 10px;
        transition: all .2s ease-in-out;

        background-size: 200% 100%;
        background-position: 200% 0;
        background-repeat: no-repeat;
        background-image: linear-gradient(90.89deg, var(--primary), var(--primary-light), transparent);

        font-weight: 700;
        font-size: 1.4rem;
        color: rgb(var(--white));

        &:after {
          content: '';
          opacity: 0;
          width: 4px;
          height: 20px;
          right: -2px;
          position: absolute;
          transition: all .2s ease-in-out;
          background-color: var(--primary-dark);
        }

        &--active {
          z-index: 2;
          background-position: 0 0;

          &::after {
            opacity: 1;
          }
        }
      }
    }
  }
</style>
